const keyRegistry = new Map<string, number>();

export const getUniqueKey = (srcId: string): string => {
  const number = keyRegistry.get(srcId);
  const newNumber = (number ?? 0) + 1;
  keyRegistry.set(srcId, newNumber);
  return `${srcId}-${newNumber}`;
};
